import Text from '$tablet-app/src/app/components/Text';
import { Allergy } from '$tablet-app/src/app/recipes/types';
import { palette } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import styled from 'styled-components/native';

interface Props extends Allergy {
  selected?: boolean;

  onPress: (allergy: string) => void;
}

const AllergyTile: FC<Props> = (props) => {
  const { icon, iconColor, image, selected, backgroundColor, text, onPress } =
    props;

  const handlePress = () => onPress(text);

  return (
    <Container onPress={handlePress} active={selected}>
      <AllergyColorSection color={backgroundColor}>
        {icon ? (
          <FontAwesomeIcon icon={icon} color={iconColor} size={45} />
        ) : null}
        {image ? <IconImage source={image} /> : null}
        {selected ? (
          <ExcludeIcon icon="ban" color={palette.primary_700} size={20} />
        ) : null}
      </AllergyColorSection>
      <BottomText variant="h3" weight="semibold">
        {text}
      </BottomText>
    </Container>
  );
};

const Container = styled.TouchableOpacity<{ active?: boolean }>`
  height: 166px;
  width: 148px;
  padding: 10px;
  border-radius: 15px;

  margin: 10px;

  border: 2px solid
    ${({ active }) => (active ? palette.primary_700 : 'lightgrey')};
`;

const AllergyColorSection = styled.View<{ color: string }>`
  background-color: ${({ color }) => color};
  border-radius: 15px;

  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  height: 103px;

  margin-bottom: 10px;
`;

const ExcludeIcon = styled(FontAwesomeIcon)`
  position: absolute;
  top: 10px;
  right: 10px;
`;

const IconImage = styled.Image`
  height: 80px;
  width: 80px;
`;

const BottomText = styled(Text)`
  text-align: center;
`;

export default AllergyTile;
